'use strict';

var utils = require('../utils');

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    var filterVisibleFields = $(this).data('filter-visible-fields') === true;
    var subscriptionCardExpired = false;
    if ($('.subscription-signup-form, .subscription-payment-form').length > 0) {
        var currentDate = new Date();
        var $monthFormGroup = $('#month').closest('.form-group');
        var $yearFormGroup = $('#year').closest('.form-group');
        if (parseInt($('#month')[0].value, 10) < (currentDate.getMonth() + 1) && parseInt($('#year')[0].value, 10) === currentDate.getFullYear()) {
            $monthFormGroup.find('.invalid-feedback')[0].innerHTML = 'This Credit Card has expired';
            $monthFormGroup.find('.invalid-feedback').show();
            $yearFormGroup.find('.invalid-feedback')[0].innerHTML = 'This Credit Card has expired';
            $yearFormGroup.find('.invalid-feedback').show();
            subscriptionCardExpired = true;
        } else {
            $monthFormGroup.find('.invalid-feedback').hide();
            $yearFormGroup.find('.invalid-feedback').hide();
        }
    }

    if ((this.checkValidity && !this.checkValidity()) || subscriptionCardExpired) {
        if ($('.payment-form, .subscription-payment-form, .subscription-signup-form').length) {
            // scroll to first error (no scroll if already in view)
            var $firstError = null;
            $('.payment-form, .subscription-payment-form, .subscription-signup-form').find('.invalid-feedback').each(function () { // eslint-disable-line consistent-return
                if ($(this)[0].innerText.length > 0 && $(this).css('display') !== 'none') {
                    $firstError = $(this);
                    return false;
                }
            });
            if ($firstError !== null) {
                setTimeout(function () {
                    var offset = 150;
                    var elementPosition = $firstError[0].getBoundingClientRect().top;
                    var offsetPosition = elementPosition - offset;
                    var isIE = false;
                    var ua = window.navigator.userAgent;
                    var oldIE = ua.indexOf('MSIE ');
                    var newIE = ua.indexOf('Trident/');

                    if ((oldIE > -1) || (newIE > -1)) {
                        isIE = true;
                    }

                    if (isIE) {
                        window.scrollBy(0, offsetPosition);
                    } else {
                        window.scrollBy({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }
                }, 0);
            }
        }
        $(this).find('input, select, textarea').filter(function () {
            return filterVisibleFields ? $(this).is(':visible') : true;
        }).each(function () {
            if (!this.validity.valid) {
                valid = false;
                $(this).trigger('invalid', this.validity);
            }
        });

        if (subscriptionCardExpired) {
            valid = false;
        }

        // safari
        if (event && !valid) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
    $(form).find('.form-group.has-error').removeClass('has-error');
}

module.exports = {
    invalid: function () {
        $('form input, form select, form textarea').on('invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;

                $(this).addClass('is-invalid').attr('aria-invalid', 'true');
                $(this).closest('.form-redesign').addClass('form-invalid');
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');

                    // overwrite the previous tooltip error message
                    if ($(this).data('wis-validation')) {
                        $(this).parents('.form-group').find('.invalid-tooltip').text(validationMessage);
                    }
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }
                $(this).parents('.form-group').addClass('has-error');
                $(this).parents('.form-group').find('.invalid-feedback').text(validationMessage);
                var $errorText = $(this).parents('.form-group').find('.invalid-feedback');
                if ($errorText && $errorText[0] && $errorText.length && !utils.isElementInViewport($errorText)) {
                    var offset = 300;
                    var elementPosition = $errorText[0].getBoundingClientRect().top;
                    var offsetPosition = elementPosition - offset;

                    window.scrollBy({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
            $(this).closest('form').find('.is-invalid')
            .first()
            .focus();
        });
    },

    submit: function () {
        $('form').on('submit', function (e) {
            return validateForm.call(this, e);
        });
    },

    buttonClick: function () {
        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents('form'));
            // special case for verification code which has value changed (may be refined later)
            var $verificationField = $('[name$="verificationCode"]');
            // remove non-formFiled errors, case for recaptcha
            if ($('.preorder-request-form').children('.alert').length > 0) {
                $('.preorder-request-form').children('.alert').remove();
            }
            if ($verificationField.length > 0) {
                if (String($verificationField[0].value.length) !== $verificationField[0].getAttribute('minlength')) {
                    $verificationField.addClass('is-invalid').attr('aria-invalid', 'true');
                    $verificationField.closest('.form-group').removeClass('is-valid').find('.invalid-feedback').text('Must be 18 characters');
                } else {
                    $verificationField.addClass('is-valid');
                    $verificationField.closest('.form-group').addClass('is-valid');
                    $verificationField.closest('.form-group').find('.invalid-feedback').text('');
                }
                // scroll to first error (no scroll if already in view)
                var $firstError = null;
                var $digitalGiftCardRefund = $('.digital-giftcard-refund');
                if ($digitalGiftCardRefund.length && $digitalGiftCardRefund.hasClass('required') && (!$digitalGiftCardRefund.find('input').is(':checked'))) {
                    $firstError = $digitalGiftCardRefund;
                } else {
                    $('.preorder-request-form').find('.invalid-feedback').each(function () { // eslint-disable-line consistent-return
                        if ($(this)[0].innerText.length > 0 && !$(this).closest('.form-group').hasClass('is-valid')) {
                            if (!$(this).closest('.form-group').hasClass('digital-giftcard-refund')) {
                                $firstError = $(this);
                                return false;
                            }
                            return true;
                        }
                    });
                }
                if ($firstError !== null && !utils.isElementInViewport($firstError.closest('.form-group'))) {
                    var offset = 150;
                    setTimeout(function () {
                        var elementPosition = $firstError[0].getBoundingClientRect().top;
                        var offsetPosition = elementPosition - offset;

                        window.scrollBy({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }, 0);
                }
            }
        });
    },

    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: clearForm
    }
};
